import * as React from "react";
import { Box } from "@mui/material";
import { StaticImage } from "gatsby-plugin-image";
import type { EventImageMap } from "../../../data/events/types";

const HERO_ALT =
  "Festa del Campo all'Aviosuperficie Boglietto: aperitivo e pizzata in pista nel Monferrato";
const SECTION_ALT =
  "Aperitivo e festa sulla pista dell'Aviosuperficie Boglietto, Costigliole d'Asti";

// Le foto Instagram erano 800x800 (sgranate sugli hero full-width): per le
// immagini grandi usiamo sorgenti ad alta risoluzione + quality 72.
export const festaDelCampoImages: EventImageMap = {
  Card: ({ eager }: { eager?: boolean }) => (
    <StaticImage
      src="../../../images/home/instagram/aviosuperficie-asti-eventi-1.jpg"
      alt={HERO_ALT}
      placeholder="blurred"
      layout="fullWidth"
      aspectRatio={16 / 9}
      quality={62}
      transformOptions={{ cropFocus: "center" }}
      loading={eager ? "eager" : "lazy"}
    />
  ),
  Hero: () => (
    <>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <StaticImage
          src="../../../images/events/acrobatics-2025/aperitivo-e-volo-acrobatico-esperienza-esclusiva-nel-monferrato.jpg"
          alt={HERO_ALT}
          placeholder="blurred"
          layout="fullWidth"
          aspectRatio={64 / 27}
          quality={72}
          transformOptions={{ cropFocus: "center" }}
        />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <StaticImage
          src="../../../images/events/acrobatics-2025/aperitivo-e-volo-acrobatico-esperienza-esclusiva-nel-monferrato.jpg"
          alt={HERO_ALT}
          placeholder="blurred"
          layout="fullWidth"
          aspectRatio={4 / 3}
          quality={72}
          transformOptions={{ cropFocus: "center" }}
        />
      </Box>
    </>
  ),
  WhenWhere: () => (
    <>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <StaticImage
          src="../../../images/home/airfield/aviosuperficie-piemonte-pista-2.jpg"
          alt={SECTION_ALT}
          placeholder="blurred"
          layout="fullWidth"
          aspectRatio={8 / 3}
          quality={72}
          transformOptions={{ fit: "cover", cropFocus: "center" }}
          style={{ height: "100%" }}
        />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <StaticImage
          src="../../../images/home/airfield/aviosuperficie-piemonte-pista-2.jpg"
          alt={SECTION_ALT}
          placeholder="blurred"
          layout="fullWidth"
          aspectRatio={16 / 9}
          quality={72}
          transformOptions={{ fit: "cover", cropFocus: "center" }}
          style={{ height: "100%" }}
        />
      </Box>
    </>
  ),
  ScheduleSide: () => (
    <StaticImage
      src="../../../images/home/landscape/aviosuperficie-boglietto-asti-colline-1.jpg"
      alt={SECTION_ALT}
      placeholder="blurred"
      layout="fullWidth"
      aspectRatio={4 / 3}
      quality={72}
      transformOptions={{ cropFocus: "center" }}
      style={{ height: "100%" }}
    />
  ),
};
